<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-product-limit-strategy">
    <div
      :class="['sky-product-limit-strategy__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.productId"
        popper-class="sky-product-limit-strategy__autocomplete"
        class="sky-product-limit-strategy__select"
        filterable
        clearable
      >
        <el-option v-for="(item, index) in productList" :key="`os${index}`" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.fitProductIdList"
        popper-class="sky-product-limit-strategy__autocomplete"
        class="sky-product-limit-strategy__select"
        filterable
        multiple
        clearable
      >
        <el-option v-for="(item, index) in productList" :key="`fit${index}`" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <i class="sk-icon-remove sk-font--B" @click="handleDelete(index)" title="点击删除"></i>
    </div>

    <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { PRODUCT_MNG } from '@/api/apiModules'

export default {
  name: 'SkyProductLimitStrategy',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    checkDuplicateVersion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      variableArr: [],
      loading: false,
      productList: []
    }
  },
  mounted() {
    action(PRODUCT_MNG, 'findAllActive').then(response => {
      this.productList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.productVersion
        }
      })
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('请补充完未填写内容')))
              break
            }
          }
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.productId && item.fitProductIdList?.length > 0
    },
    handleAdd() {
      this.variableArr.push({
        productId: null,
        fitProductIdList: []
      })
    },
    handleFill(value) {
      this.variableArr = value
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(product-limit-strategy) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 280px !important;
  }
  @include e(multiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
    cursor: pointer;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
